import { render, staticRenderFns } from "./product-supliers-details.vue?vue&type=template&id=52f4fe24&scoped=true"
import script from "./product-supliers-details.vue?vue&type=script&lang=js"
export * from "./product-supliers-details.vue?vue&type=script&lang=js"
import style0 from "./product-supliers-details.vue?vue&type=style&index=0&id=52f4fe24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f4fe24",
  null
  
)

export default component.exports